import {ChangeEvent, FC, useState, useRef, useEffect} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {Button} from '../../../../../../components/UI/Button'
import {
  downloadTemplateTicket,
  downloadTemplateTicketV,
  uploadMasiveTicket,
} from '../../../../services'
import {ModalErrorUpload} from '../../PointWrapper/Modal/ModalErrorResumenUpload'
import {ShowSnackBar} from '../../../../../../util/functions'
import Poppup from '../../../../../../components/UI/Poppup'
const MasiveTicket: FC = () => {
  const [file, setFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState<File | null>(null)
  const [error, setError] = useState('')
  const [show, setShow] = useState(false)
  const [intervalId, setIntervalId] = useState(null)
  const [progress, setProgress] = useState(0)
  const [showPoppup, setShowPoppup] = useState(false)
  const [loadingDownload, setLoadingDownload] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [intervalId])

  const incrementProgress = () => {
    setProgress((prev: any) => (prev < 90 ? prev + 1 : prev))
  }

  const handleGetTemplate = async () => {
    try {
      setLoadingDownload(true)
      const response = (await downloadTemplateTicketV()) as any
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Plantilla_Descarga_AutoAdhesivos.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setFileName(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleUpload = async () => {
    try {
      if (file) {
        setError('')
        let success = false
        const formData = new FormData()
        formData.append('test', file)
        const interval = setInterval(incrementProgress, 500)
        setIntervalId(interval as any)
        setShowPoppup(true)
        const response = await uploadMasiveTicket(formData) // Use the service to upload the file
        success = response?.data.error
        if (!response.data.error) {
          const blob = new Blob([response.data], {type: 'application/pdf'})
          // Crea un enlace temporal y simula un clic para descargar el archivo
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Tickets Masivos' // Ajusta el nombre del archivo según tus necesidades
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        if (fileInputRef.current) {
          fileInputRef.current.value = '' // Borra la selección de archivo
        }
        clearInterval(interval)

        // Iniciar el incremento final hasta 100%
        const completeInterval = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 100) {
              clearInterval(completeInterval)
              setShowPoppup(false)
              if (!success) {
                ShowSnackBar('Documento generado correctamente')
              } else {
                setShow(true)
              }
              return prev
            }
            return prev + 1
          })
        }, 15)
        setFile(null)
      } else {
        setError('Este campo es requerido')

        console.error('No file selected.')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <form>
          <div className='p-6'>
            <div className='row'>
              <div className='mb-12 col-sm-12 col-lg-12'>
                <Button
                  onClick={handleGetTemplate}
                  label='Descargar Plantilla'
                  loading={loadingDownload}
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
                <label className='required form-label'>Examinar</label>
                <div className='input-group input-group-sm'>
                  <input
                    className='form-control'
                    type='file'
                    id='formFileRoom'
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                </div>
                {showPoppup && (
                  <Poppup
                    progress={progress}
                    text={
                      'Se está cargando la información, espere un momento mientras termine de procesar ...'
                    }
                  />
                )}
                {error && <p className='error-message'>{error?.toString()}</p>}
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-center mb-3'>
            <Button onClick={handleUpload} label='Generar' />
          </div>
        </form>
        <ModalErrorUpload show={show} setShow={setShow} message={[]} file={fileName} />
      </KTCard>
    </>
  )
}

export {MasiveTicket}
